import styled from "styled-components"

export const Grid = styled.div`
  display: grid;
  gap: 2.5rem;
  @media (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 3rem;
  }
`

export const Card = styled.figure`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0.25rem 0 0.25rem 1.5rem;
  border-left: 4px solid var(--sky);
  blockquote {
    flex: 1 1 auto;
  }
  blockquote p {
    margin: 0 0 1.25rem;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.35;
    letter-spacing: -0.01em;
    color: var(--ink);
  }
  figcaption {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    font-size: 0.95rem;
  }
  figcaption span {
    color: var(--muted);
  }
  figcaption small {
    margin-top: 0.35rem;
    font-size: 0.8rem;
    color: var(--muted);
  }
`
